import { AiOutlineQrcode } from 'react-icons/ai';
import { SwiperItemAttrs } from '../../SwiperConfigable';
import { Flex } from '@/components/common';
import { TFunction } from 'i18next';
import { format } from 'date-fns-jalali/format';
import { fromUnixTime } from 'date-fns-jalali/fromUnixTime';

export default function createSwiperItem(item: any, t: TFunction): SwiperItemAttrs {
  let date: string;
  if (typeof item?.reserve?.programDateTime === 'number') {
    date = format(fromUnixTime(item?.reserve?.programDateTime / 1000), 'yyyy/MM/dd hh:mm');
  }

  console.log(item);


  return {
    id: item?.reserve?.id,
    count: item?.reserve?.selectedCount,
    title: item?.name ?? t('common:labels.empty-field'),
    subTitle: item?.reserve?.selfCodeName,
    description: item?.reserve?.foodNames ?? t('common:labels.empty-field'),
    secondaryDescription: item?.reserve?.besideFoodNames,
    disabled: item?.reserve?.consumed,
    foodImageSrc: item?.reserve?.foodImageSrc,
    startServeTime: item?.startServeTime?.timeStr,
    endServeTime: item?.endServeTime?.timeStr,
    demonstrationDescription: item?.demonstrationDescription,
    data: {
      date,
      foodTypeTitle: item?.reserve?.foodTypeTitle,
      isDailyReserve: item?.reserve?.isDailyReserve,
    },
    actionButtonContent: item?.reserve?.consumed ? null : (
      <Flex gap={4} justify="center">
        <AiOutlineQrcode style={{ fontSize: '1.2rem' }} />
        <span>{t('common:labels.forget')}</span>
      </Flex>
    )
  } as SwiperItemAttrs;
}
